import { Hero, SectionHeader } from '@/components/marketing/primitives.jsx';

export default function Terms() {
  return (
    <>
      <Hero
        eyebrow="Terms of Use"
        title="The conditions under which NACIS is made available."
        description="These terms apply to all users of NACIS platforms — citizen, agency, institutional partner, judicial reviewer, and oversight — in addition to any separately signed integration charter."
      />

      <section className="py-16 md:py-20">
        <div className="container-narrow">
          <div className="prose-marketing">
            <p className="text-sm text-slate-500">Last updated: April 2026</p>

            <SectionHeader
              eyebrow="Agreement"
              title="Use of NACIS means agreement to these terms."
            />

            <h2>1. Acceptance</h2>
            <p>
              By accessing or using any NACIS service — web, mobile, or API — you agree to be bound by these Terms.
              If you access NACIS on behalf of an agency, institution, or jurisdiction, you represent that you have
              authority to bind that entity.
            </p>

            <h2>2. Accounts and credentials</h2>
            <p>
              You are responsible for maintaining the confidentiality of your credentials and for all activity that
              occurs under them. You must report any suspected credential compromise through the responsible-disclosure
              path without delay.
            </p>

            <h2>3. Acceptable use</h2>
            <ul>
              <li>Do not submit reports you know to be false.</li>
              <li>Do not attempt to access records outside your authorised scope.</li>
              <li>Do not interfere with the operation of NACIS or evade security controls.</li>
              <li>Do not use NACIS to harass, intimidate, or retaliate against any person.</li>
              <li>Do not export or re-disseminate records in violation of your integration charter.</li>
            </ul>

            <h2>4. Federated integration charter</h2>
            <p>
              Agency and institutional partners are bound by both these Terms and their separately signed federated
              integration charter. Where the two conflict, the charter controls for the signing partner.
            </p>

            <h2>5. Intellectual property</h2>
            <p>
              The NACIS platform, including its design, code, and documentation, is protected intellectual property.
              Partners receive a limited, revocable, non-transferable license to use NACIS consistent with their tier
              and their signed charter.
            </p>

            <h2>6. No warranty for out-of-scope use</h2>
            <p>
              NACIS is provided for its declared civic trust-fabric purposes. Use outside of those purposes is at your
              own risk and is not covered by any warranty, explicit or implied.
            </p>

            <h2>7. Limitation of liability</h2>
            <p>
              To the maximum extent permitted by law, NACIS and its operators are not liable for indirect, incidental,
              or consequential damages arising from your use of the platform. Partner-specific liability caps and
              carve-outs are set in the federated integration charter.
            </p>

            <h2>8. Suspension and termination</h2>
            <p>
              We may suspend or terminate access for material breach of these Terms or a partner's charter, for
              credential compromise, or under court order. Where possible, we provide notice and a remediation
              window before termination.
            </p>

            <h2>9. Changes to these terms</h2>
            <p>
              Material changes are published with an effective date at least 30 days in advance. Continued use after
              the effective date constitutes acceptance. Partners receive direct notice through their charter contact.
            </p>

            <h2>10. Governing law</h2>
            <p>
              These Terms are governed by the laws of the United States. Disputes with federated partners are resolved
              under the dispute-resolution framework declared in the integration charter.
            </p>

            <h2>11. Contact</h2>
            <p>
              Questions about these Terms, suspension or termination actions, or requests for clarification can be
              directed through the Contact page.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
